import React from 'react'

import { Person } from '../../App/store/features/person/IPerson'
import { TOpenEventDetails, IAppointment } from '../types'
import { isInstanceOfAppointment } from '../types/api'

import { CreateNavigation } from './CreateNavigation'
import { NavigationTitle } from './NavigationTitle'
import { UpdateNavigation } from './UpdateNavigation'

const makePanelTitle = (openEventDetails: TOpenEventDetails): string | null => {
  if (openEventDetails.type === 'create_appointment') {
    return 'Create appointment'
  }
  if (openEventDetails.type === 'create_block') {
    return 'Create block'
  }
  if (openEventDetails.type === 'create_lastMinutes') {
    return 'Create last minute'
  }
  if (openEventDetails.type === 'update_appointment_details') {
    return 'Update appointment'
  }
  if (openEventDetails.type === 'update_appointment_notes') {
    return 'Update appointment notes'
  }
  if (openEventDetails.type === 'update_appointment_print') {
    return 'Update appointment print'
  }
  if (openEventDetails.type === 'update_appointment_delete') {
    return 'Delete appointment'
  }
  if (openEventDetails.type === 'update_block') {
    return 'Update block'
  }
  return null
}

interface IProps {
  openEventDetails: TOpenEventDetails
  personList: Person[]
}

export const CrudPanelNavigation = ({
  openEventDetails,
  personList,
}: IProps) => {
  const createPanelActions: TOpenEventDetails['type'][] = [
    'create_appointment',
    'create_lastMinutes',
    'create_block',
  ]
  const isCreateAction: boolean = createPanelActions.includes(
    openEventDetails.type,
  )
  const panelTitle = makePanelTitle(openEventDetails)

  if (isCreateAction) {
    return (
      <CreateNavigation
        openEventDetails={openEventDetails}
        firstPersonInList={personList[0]}
        panelTitle={panelTitle}
      />
    )
  }

  if (isInstanceOfAppointment(openEventDetails.event)) {
    const openAppointment: IAppointment = openEventDetails.event as IAppointment
    return (
      <UpdateNavigation
        openEventDetails={openEventDetails}
        openAppointment={openAppointment}
        panelTitle={panelTitle}
      />
    )
  }

  if (openEventDetails.type === 'update_block') {
    return <NavigationTitle panelTitle={panelTitle} />
  }

  return null
}
